<template>
	<tbody v-if="userReport">
		<tr class="user-heading">
			<th :colspan="colspan">
				<div class="d-flex align-items-baseline flex-wrap">
					<h3 class="mr-4">
						<router-link v-if="userReport.slug" :to="'/employee/'+userReport.slug+'/profile'">{{ userReport.fullName }}</router-link>
						<span v-else>{{ userReport.fullName }}</span>
					</h3>

					<span v-if="employeeNum" class="text-muted font-weight-light">
						Employee #{{employeeNum}}
					</span>
				</div>
			</th>
		</tr>
		<tr class="hours-heading">
			<th style="width: 300px">
				<template v-if="$store.timeLogSettings.report_display_job == 1">Project/Service</template>
				<template v-else-if="$store.timeLogSettings.report_display_customer == 1">Customer</template>
			</th>
			<th v-if="$store.timeLogSettings.report_display_rate == 1" >Rate</th>
			<th v-if="$store.timeLogSettings.report_display_payboosts == 1" >Pay Adjustments</th>
			<!--<th style="width: 150px">Job Role</th>
			<th style="width: 150px">Col. Agr.</th>
			<th style="width: 200px">Classification</th>-->
			
			<th style="width: 60px" v-for="day in periodDays" class="right">{{ day.format("MMM D") }}</th>
			<th v-if="$store.timeLogSettings.report_display_total == 1" style="width: 60px" class="right">Total</th>
		</tr>
		<tr v-for="line in userReport.payrollLines">
			<td>
				<router-link  v-if="$store.timeLogSettings.report_display_job == 1" :to="line.jobType == 'Job' ? '/project/'+line.job_slug+'/dashboard' : '/service/'+line.job_slug+'/dashboard'" v-html="line.jobLabel">
					{{ line.jobLabel }}
				</router-link>
				<div v-if="line.job.Customer && $store.timeLogSettings.report_display_customer == 1">
					<router-link :to="'/contact/'+line.job.Customer.slug+'/details'" :title="line.job.ContactLocation ? line.job.ContactLocation.location_name : line.job.Customer.name">
						<em>{{ line.job.Customer.name }}</em>
					</router-link>
				</div>
			</td>
			<td v-if="$store.timeLogSettings.report_display_rate == 1">{{ line.rateLabel }}</td>
			<td v-if="$store.timeLogSettings.report_display_payboosts == 1" v-html="line.payBoostExplanation"></td>
			<!--<td>{{ line.jobRole }}</td>
			<td>{{ line.collectiveAgreementName }}</td>
			<td>{{ line.classification }}</td>-->
			
			<td v-for="(day,index) in periodDays" class="right time-log-day-cell">
				<button v-for="(lineDay, key) in line.days" v-if="day.format('YYYY-MM-DD') == key" class="btn btn-link" v-on:click="viewDayLogs(key,line)">
					{{ line.days[day.format("YYYY-MM-DD")].toFixed(2) }}
				</button>
			</td>
			<th v-if="$store.timeLogSettings.report_display_total == 1"  class="right" :style="{color:line.textColor}">{{ line.lineTotal.toFixed(2) }}</th>
		</tr>
		<tr>
			<!--<th :colspan="$store.timeLogSettings.report_display_total == 1 ? colspan - 8 : colspan - 7" class="right">Total</th>-->
			<th :colspan="$store.timeLogSettings.report_display_total == 1 ? colspan - periodDays.length - 1 : colspan - periodDays.length">Total</th>
			<th v-for="day in periodDays" class="right">

				<template v-for="(dayTotal, key) in userReport.dailyTotals" v-if="day.format('YYYY-MM-DD') == key">
					{{ dayTotal.toFixed(2) }}
				</template>
			</th>
			<th v-if="$store.timeLogSettings.report_display_total == 1" class="right">{{ userReport.grandTotal.toFixed(2) }}</th>
		</tr>
		<tr>
			<td :colspan="colspan + 1">
				<div v-for="(ca,key) in userReport.caTotals" class="d-flex flex-column align-items-end mb-1" :style="{color:ca.color}">
					<div class="mr-2">
						<strong>{{key}} Totals</strong>
					</div>
					<info-box v-for="(typeTotal,label) in ca" v-if="label != 'color'"
						class="ml-1"
						:key="label"
						:label="label"
						:value="typeTotal.toFixed(2)">
					</info-box>
					
				</div>
			</td>
		</tr>
		<tr class="mileage-heading">
			<th :colspan="colspan + 1"><h4>Additional Compensation</h4></th>
		</tr>
		<tr>
			<th>Date</th>
			<th>Col. Agr.</th>
			<th :colspan="colspan - 7">Project/Service</th>
			<th colspan="2">Distance</th>
			<th colspan="2" class="right">Per Diem</th>
			<th colspan="2" class="right">Mileage Pay</th>
		</tr>
		<tr v-for="mileage in userReport.mileage">
			<td>{{moment(mileage.day).format("MMM DD")}}</td>
			<td>{{ mileage.collectiveAgreement }}</td>
			<td :colspan="colspan - 7">{{mileage.job_num}} {{mileage.job_name}}</td>
			<td colspan="2">{{ mileage.distance }} km</td>
			<td colspan="2" class="right">{{ mileage.per_diem }}</td>
			<td colspan="2" class="right">{{ mileage.mileage_pay }}</td>
		</tr>
		<tr>
			<th :colspan="colspan - 5" class="right">Totals</th>
			<th colspan="2">{{ userReport.totalMileageKm }} km</th>
			<th colspan="2" class="right">{{ userReport.totalPerDiemPay }}</th>
			<th colspan="2" class="right">{{ userReport.totalMileagePay }}</th>
		</tr>
		<tr>
			<td :colspan="colspan + 2" class="pb-4">
				<button v-if="!userNoteToggle && !$store.printMode && !readonly" class="btn btn-light" v-on:click="$emit('toggleNote',userReport.id)">
					<i class="fa fa-pencil-alt"></i>
					Write Note...
				</button>

				<form v-if="userNoteToggle && !readonly" v-on:submit.prevent="$emit('saveNote',userReport.id,userNoteLocal)">
					<field :label="'Notes for '+userReport.fullName" col-class="stacked" :params="{type:'textarea'}" v-model="userNoteLocal"></field>

					<div class="float-right" v-if="!working && !$store.printMode">
						<button type="button" class="btn btn-light" v-on:click="$emit('toggleNote',userReport.id)">
							<i class="fa fa-times"></i>
							Cancel
						</button>
						<button type="submit" class="btn btn-success">
							<i class="fa fa-save"></i>
							Save
						</button>
					</div>
					<div v-else class="float-right">
						<i class="fa fa-spinner fa-spin"></i>
						Saving...
					</div>
					<div style="clear: both;"></div>
				</form>

				<div v-else-if="userNoteLocal || readonly" class="d-flex flex-row align-items-center alert alert-info mt-2">
					<i class="fa fa-2x fa-exclamation-circle text-info mr-3"></i>
					<form-group :label="'Notes for '+userReport.fullName" col-class="stacked">
						<pre style="margin: 0;font-size: 14pt;font-family: inherit;">{{ userNoteLocal }}</pre>
					</form-group>
				</div>
				
			</td>
		</tr>
		<tr>
			<th :colspan="colspan + 2"><h4>Time Log Notes</h4></th>
		</tr>
		<template v-if="userReport.logs.filter(log => log.review_notes).length > 0">
			<tr>
				<th>Project/Service</th>
				<th>Log Date</th>
				<th :colspan="colspan - 1">Note</th>
			</tr>
			<tr v-for="log in userReport.logs.filter(log => log.review_notes)">
				<td>#{{ log.Job ? log.Job.job_num : log.Service.job_num }}: {{ log.Job ? log.Job.job_name : log.Service.job_name }}</td>
				<td>
					{{ formatDateTimeToLocal(log.time_in) }}
				</td>
				<td :colspan="colspan - 1">
					{{ log.review_notes }}
				</td>
			</tr>
		</template>
		<tr v-else>
			<td :colspan="colspan + 1">No review notes for this user</td>
		</tr>
	</tbody>
</template>
<script type="text/javascript">
import InfoBox from "@/components/InfoBox"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"

export default {
	name: "PeriodReportUser",
	props: [
		"userReport",
		"colspan",
		"periodDays",
		"userNoteToggle",
		"userNote",
		"working",
		"readonly",
		"user"
	],
	components: {
		InfoBox,
		Field,
		FormGroup
	},
	data() {
		return {
			userNoteLocal: ""
		}
	},
	watch: {
		userNote() {
			this.userNoteLocal = this.userNote
		}
	},
	computed: {
		employeeNum() {
			if (this.user &&
				'EmployeeSetting' in this.user && this.user.EmployeeSetting.length &&
				'employee_num' in this.user.EmployeeSetting[0] && this.user.EmployeeSetting[0].employee_num != "")
			{
				return this.user.EmployeeSetting[0].employee_num
			}

			return false
		}
	},
	methods: {
		viewDayLogs(date,line) {
			this.$emit("viewDayLogs",{
				date: date,
				job_id: line.job_id,
				jobType: line.jobType,
				rateLabel: line.rateLabel
			})
		}
	},
	created() {
		this.userNoteLocal = this.userNote
	}

}
</script>

<style type="text/css" scoped>
	.time-log-day-cell .btn-link {
		padding: 0;
		font-family: inherit;
		font-size: inherit;
	}
</style>